// extracted by mini-css-extract-plugin
export var BookListing = "BookListing-module--BookListing--AidNo";
export var doubleCoulumn = "BookListing-module--doubleCoulumn--PC4lQ";